import React, { forwardRef, useImperativeHandle, useState } from 'react';
import { Col, Text, TextArea } from 'components';
import { SCREEN } from 'const';
import { Modal } from 'antd';
import { useOrderStore } from 'store/Order.Store';
import { useNavFunc } from 'navigation';

const RejectOrderModal = ({ selectedOrders }: { selectedOrders: any }, ref) => {
  const [show, setShow] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [reason, setReason] = useState('');
  const OrderStore = useOrderStore();
  const { navigation } = useNavFunc();

  useImperativeHandle(ref, () => ({
    show: () => {
      setShow(true);
      setReason('');
      setError('');
      setLoading(false);
    },
  }));

  const onSubmit = async () => {
    try {
      if (loading) return;
      setError('');
      setLoading(true);
      await OrderStore.updateOrderStage(selectedOrders, {
        Status: "Rejected",
        Stage: "Cancelled",
        StageStatus: "Rejected",
      }, { reason })
      setTimeout(() => {
        setShow(false);
        navigation.navigate(SCREEN.ListOrders, { stage: 'cancelled' });
      }, 600);
    } catch (error) {
      setError(error.message || JSON.stringify(error));
    } finally {
      setLoading(false);
    }
  }

  return (
    <Modal
      open={show}
      title={`Reject order${selectedOrders?.length > 1 ? 's' : ''}`}
      onOk={onSubmit}
      onCancel={() => setShow(false)}
      okText="Send"
      confirmLoading={loading}
    >
      <Col height={12} />
      <TextArea
        height={80}
        placeholder='Enter reason'
        value={reason}
        onChangeText={setReason}
      />
      <Text mt2 color="red">{error}</Text>
    </Modal>
  );
};

export default forwardRef(RejectOrderModal);
